export default Object.freeze({
    NOT_INVITED: 0,
    INVITED: 1,
    PROCESSING: 2,
    REGISTRATION_NOT_COMPLETED: 3,
    REGISTRATION_COMPLETED: 4,
})
